// react
import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
import Api from '@/api'
import {AppType} from '@/enum'

/**
 * 合思配置表单项
 * @constructor
 */
const WangShangFormItems = () => {
  return (
    <>
      <ProFormText
        name={["config", "appid"]}
        label={"appid"}
        placeholder={"请输入appid"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入appid"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "partner"]}
        label={"partner"}
        placeholder={"请输入partner"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入partner"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "rsaPublicKey"]}
        label={"rsaPublicKey"}
        placeholder={"请输入rsaPublicKey"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入rsaPublicKey"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "rsaPrivateKey"]}
        label={"rsaPrivateKey"}
        placeholder={"请输入rsaPrivateKey"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入rsaPrivateKey"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "reqTimeZone"]}
        label={"reqTimeZone"}
        placeholder={"请输入reqTimeZone"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入reqTimeZone"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "resourcesPath"]}
        label={"resourcesPath"}
        placeholder={"请输入resourcesPath"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入resourcesPath"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "reqUrl"]}
        label={"reqUrl"}
        placeholder={"请输入reqUrl"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入reqUrl"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "sftpProtocal"]}
        label={"sftpProtocal"}
        placeholder={"请输入sftpProtocal"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入sftpProtocal"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "sftpHost"]}
        label={"sftpHost"}
        placeholder={"请输入sftpHost"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入sftpHost"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "sftpPort"]}
        label={"sftpPort"}
        placeholder={"请输入sftpPort"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入sftpPort"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "sftpUsername"]}
        label={"sftpUsername"}
        placeholder={"请输入sftpUsername"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入sftpUsername"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "sftpPassword"]}
        label={"sftpPassword"}
        placeholder={"请输入sftpPassword"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入sftpPassword"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "remark"]}
        label={"remark"}
        placeholder={"请输入remark"}
        width={"lg"}
        rules={[
          {
            message: "请输入remark"
          }
      ]}
      />
    </>
  )
}

export default WangShangFormItems
